module.exports = __webpack_public_path__ + "resources/img/bg_cover_service_m.732751d2febd8ac38b9b95ed038982e5.png";